import React, { useEffect } from 'react'
import Pagination from '../search/forms/Pagination'
import { selectMembers,selectPage, selectTotalCount, selectTotalPages } from '../../reducers/membersReducer';

import {fetchMembers} from "../../fetch/search"

import Row from "../search/Row";
import { useDispatch, useSelector } from 'react-redux';

export default function MembersPagination({term}) {

    const members = useSelector(selectMembers);
    const page = useSelector(selectPage);
    const count = useSelector(selectTotalCount);
    const totalPages = useSelector(selectTotalPages);

  

    const dispatch = useDispatch();

    var getItems = () => {
      return members.map(a=>
      {return (<Row hasHouseHold={false} isOnPhoto={a.hasPicture} id={a.rbrPopulacija} photo={a.documentId} title={a.име +(a.имеОца?" ("+a.имеОца+") ":" ")+ a.презиме} text={a.годРођења && (a.годРођења + (a.годСмрти?(" - "+a.годСмрти):"")) || ""}></Row>)
    })
    }

  return (
    <Pagination onPageSet={(e)=>{

        dispatch(fetchMembers({param:term, page:e}));


    }} count={count} items={getItems()} pagenum={page} totalpages={totalPages} />
  )
}
